export const SELECT_OPTIONS_VDI = {
  name: 'comment',
  label: 'Задачи для VDI',
  options: [
    { value: 'value1', label: 'Вторая жизнь старых компьютеров' },
    { value: 'value2', label: 'Проектирование и дизайн' },
    { value: 'value3', label: 'Масштабирование' },
    { value: 'value4', label: 'Удаленная работа в несколько смен' },
  ],
};

export const SELECT_OPTIONS_GPU = {
  name: 'comment',
  label: 'Вычислительные мощности',
  options: [
    { value: 'virtual-machines', label: 'Виртуальные машины с GPU' },
    { value: 'ml-service', label: 'ML-сервис' },
    { value: 'dedicated-server', label: 'Выделенный сервер с GPU' },
    {
      value: 'optional-variant',
      label: 'Подберите оптимальный вариант под мою задачу',
    },
  ],
};

export const NO_INDEX_PAGES = [
  'access-to-virtual-machines-with-gpu',
  'gpu',
  'cloud-backup-and-recovery',
  'virtual-private-cloud',
  'bare-metal',
  'cloud-managed-kubernetes',
  'cloud-container-engine',
  'object-storage',
  'elastic-load-balance',
  'cloud-container-engine',
  'elastic-volume-service',
  'image-management-service',
  'tag-management-service-tms',
  'virtual-private-cloud-and-elastic-ip',
  'elastic-cloud-server',
  'relational-databases-service-postgresql',
];

export const BUTTON_TITLE = 'Попробовать бесплатно';
export const SECOND_BUTTON_TITLE = 'Связаться с нами';
